import React from 'react'

export const UserStroke = () => (
  <svg
    width='15px'
    height='16px'
    viewBox='0 0 15 16'
    version='1.1'
    xmlns='http://www.w3.org/2000/svg'
    xmlnsXlink='http://www.w3.org/1999/xlink'
  >
    <title>Name Icon</title>
    <g id='Page-1' stroke='none' strokeWidth='1' fill='none' fillRule='evenodd'>
      <g
        id='Search-Results'
        transform='translate(-90.000000, -126.000000)'
        fill='#FFFFFF'
        fillRule='nonzero'
        stroke='#473545'
        strokeWidth='1.2'
      >
        <g id='noun_avatar_218743' transform='translate(91.000000, 127.000000)'>
          <path
            d='M6.51382979,0 C4.30106383,0 3.33297872,1.8393617 3.33297872,3.70638298 C3.33297872,6.15425532 4.79893617,7.2606383 4.79893617,8.07659574 C4.79893617,8.39468085 4.57765957,8.79574468 3.96914894,9.11382979 L0.732978723,10.8287234 C-0.40106383,11.4510638 0.165957447,13.8297872 0.165957447,13.8297872 L12.8478723,13.8297872 C12.8478723,13.8297872 13.4010638,11.4510638 12.2670213,10.8287234 L9.03085106,9.1 C8.43617021,8.78191489 8.15957447,8.43617021 8.15957447,8.11808511 C8.15957447,7.3712766 9.65319149,6.30638298 9.65319149,3.6787234 C9.66702128,1.49361702 8.50531915,0 6.51382979,0 Z'
            id='Path'
          ></path>
        </g>
      </g>
    </g>
  </svg>
)

export default UserStroke
